module.exports = __webpack_public_path__ + "static/media/new.1bb6b795.svg";